import { createElement } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { App } from '../App';
import type { ResponseModel } from '../priceStatistic';
import './styles.css';

type DeviceType = 'mobile' | 'tablet' | 'desktop';

type AppProps = {
    adId: number;
    deviceType: DeviceType;
    response: ResponseModel;
    showLink: boolean;
};

const ROOT_ID = 'price-statistics-podlet-root';
const CONFIG_ID = 'price-statistics-podlet-config';

const shadowRoot = document.querySelector('price-statistics-podlet')?.shadowRoot;

if (shadowRoot) {
    const stylesheets = [
        'https://assets.finn.no/pkg/@warp-ds/css/v2/components.css',
        'https://assets.finn.no/pkg/@warp-ds/css/v2/tokens/finn-no.css',
        'https://assets.finn.no/pkg/@warp-ds/fonts/v1/finn-no.css',
        'https://assets.finn.no/pkg/@warp-ds/css/v2/resets.css',
    ];

    for (const href of [...stylesheets]) {
        let link = shadowRoot.querySelector<HTMLLinkElement>(`link[href="${href}"]`);

        if (!link) {
            link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
        }

        shadowRoot.prepend(link);
    }
}

const root = shadowRoot?.getElementById(ROOT_ID) ?? document.getElementById(ROOT_ID);
const configElement = shadowRoot?.getElementById(CONFIG_ID) ?? document.getElementById(CONFIG_ID);

if (root && configElement?.textContent) {
    const props = JSON.parse(configElement.textContent) as AppProps;
    hydrateRoot(root, createElement(App, props));
}
